module.exports = __webpack_public_path__ + "static/img/train-phone.92138e5f.png";